import React from 'react';
import classNames from 'classnames';
import  CustomLink from '../../elements/CustomLink';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <CustomLink to="/">
          {/* <Image
            src={require('./../../../assets/images/logo.svg')}
            alt="logo"
            width={32}
            height={32} /> */}
        </CustomLink>
      </h1>
    </div>
  );
}

export default Logo;